'use client';

import { createContext, FC, ReactNode, useContext, useRef } from 'react';
import { useStore } from 'zustand';
import { User } from 'lucia';
import { createCreditStore, CreditStore } from '../stores/credit-store';

export type CreditStoreApi = ReturnType<typeof createCreditStore>;

export const CreditStoreContext = createContext<CreditStoreApi | undefined>(undefined);

interface CreditStoreProviderProps {
    user: User | null;
    children: ReactNode;
}

export const CreditStoreProvider: FC<CreditStoreProviderProps> = ({ user, children }) => {
    const storeRef = useRef<CreditStoreApi>(createCreditStore({ credits: user?.credits ?? 0 }));

    return (
        <CreditStoreContext.Provider value={storeRef.current}>
            {children}
        </CreditStoreContext.Provider>
    );
};

export const useCreditStore = <T,>(
    selector: (store: CreditStore) => T,
): T => {
    const creditStoreContext = useContext(CreditStoreContext);
    if (!creditStoreContext) {
        throw new Error('useCreditStore must be used within a CreditStoreProvider');
    }

    return useStore(creditStoreContext, selector);
};
